import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=47c5997d&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=47c5997d&scoped=true&lang=css"
import style1 from "./Tags.vue?vue&type=style&index=1&id=47c5997d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c5997d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c5997d')) {
      api.createRecord('47c5997d', component.options)
    } else {
      api.reload('47c5997d', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=47c5997d&scoped=true", function () {
      api.rerender('47c5997d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Tags.vue"
export default component.exports